import React, { useState } from 'react';

const addUser = async (userData) => {
  let wsUrl = `${import.meta.env.VITE_REACT_APP_BACK_SPRING_USER_ENDPOINT}/login`;
  try {
    const response = await fetch(wsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(userData)
    });

    if (response.ok) {
      let data = await response.json();
      console.log("response data : " + JSON.stringify(data));
      // Faites quelque chose avec les données renvoyées par le backend
    } else {
      let text = await response.text();
      console.log("error response text : " + text);
      // Faites quelque chose en cas d'erreur, comme afficher un message d'erreur
    }
  } catch (ex) {
    console.log("ex : " + ex);
    // Faites quelque chose en cas d'erreur générale, comme afficher un message d'erreur
  }
};

const UserAdd = () => {
  const [formData, setFormData] = useState({
    email_address: "",
    password: "",
    first_name: "",
    last_name: ""
  });

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    addUser(formData);
  };

  return (
    <div>
      <h1>Add User</h1>
      <form onSubmit={handleSubmit}>
        <label>
          Username:
          <input type="text" name="username" value={formData.username} onChange={handleChange} />
        </label>
        <br />
        <label>
          Email Address:
          <input type="text" name="email_address" value={formData.email_address} onChange={handleChange} />
        </label>
        <br />
        <label>
          Password:
          <input type="text" name="password" value={formData.password} onChange={handleChange} />
        </label>
        <br />
        <label>
          First Name:
          <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} />
        </label>
        <br />
        <label>
          Last Name:
          <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} />
        </label>
        <br />
        <button type="submit">Add</button>
      </form>
    </div>
  );
};

export default UserAdd;
